"use strict";

// More info for using bootstrap via npm:
// https://getbootstrap.com/docs/5.0/getting-started/download/#npm
import "bootstrap";

/*! Webfont loader *
 * Source: https://github.com/typekit/webfontloader
 * Loading server fonts to avoid cookies mesasge*/
import WebFont from "webfontloader";

WebFont.load({
  custom: {
    families: ["Source+Sans+Pro:400,400i,700,700i", "League+Spartan:400,700"],
    urls: ["/assets/fonts/fonts.css"],
  },
});
/* Webfont loader */

// Import glider slider
//import "../node_modules/glider-js/glider.min.js";
import "./glider.min.js";

// Initialise Glider
let GliderExists = false;
GliderExists = document.querySelector(".glider");

if (GliderExists) {
  new Glider(GliderExists, {
    // Mobile-first defaults
    slidesToShow: 1.5,
    slidesToScroll: 1,
    scrollLock: true,
    dots: ".glider-dots",
    arrows: {
      prev: ".glider-prev",
      next: ".glider-next",
    },
    draggable: true,
    dragVelocity: 3.3,
    easing: function (x, t, b, c, d) {
      return c * (t /= d) * t + b;
    },
    responsive: [
      {
        // screens greater than >= 775px
        breakpoint: 775,
        settings: {
          // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: "auto",
          slidesToScroll: "auto",
          itemWidth: 280,
          duration: 0.25,
        },
      },
      // 576, 768, 992, 1200
      {
        // screens greater than >= 1200px
        breakpoint: 1200,
        settings: {
          slidesToShow: "auto",
          slidesToScroll: "auto",
          itemWidth: 350,
        },
      },
      {
        // screens greater than >= 1400px
        breakpoint: 1900,
        settings: {
          slidesToShow: "auto",
          slidesToScroll: "auto",
          itemWidth: 400,
        },
      },
    ],
  });
}

/** Simple Lightbox initialisation */
import SimpleLightbox from "simplelightbox";

const lightboxKamenivo = new SimpleLightbox(".card-shop-product .lightbox-img", {});

/** Timeline controls */
const timelineExists = document.querySelector(".timeline") !== null,
  controlsLeftExists = document.querySelector(".timeline-left") !== null,
  controlsRightExists = document.querySelector(".timeline-right") !== null;

if (timelineExists && controlsLeftExists && controlsRightExists) {
  // Get controls and the timeline, but only if those exist on the page
  const timelineContainer = document.querySelector(".timeline"),
    timelineInner = document.querySelector(".timeline-inner"),
    buttonLeft = document.querySelector(".timeline-left"),
    buttonRight = document.querySelector(".timeline-right");

  const timelineEvents = timelineContainer.childElementCount;
  const timelineWidth = timelineContainer.offsetWidth;
  const timelineInnerWidth = timelineInner.offsetWidth;

  // Add action to button to move left
  buttonLeft.addEventListener("click", function () {
    timelineContainer.scrollBy({
      top: 0,
      left: -400,
      behavior: "smooth",
    });
  });

  // Add action to button to move right
  buttonRight.addEventListener("click", function () {
    timelineContainer.scrollBy({
      top: 0,
      left: 400,
      behavior: "smooth",
    });
  });
}

// Mise vize strategie – Controls and switches images that are shown
// Get Pills that control tabs
const tabEls = document.querySelectorAll('.widget-mise button[data-bs-toggle="pill"]');
tabEls.forEach((tabEl) => {
  if (tabEl !== null) {
    // Listen to on.tab.show event and change visibility of images according to
    // data-target-img attribute of present and previous tabs
    tabEl.addEventListener("shown.bs.tab", (event) => {
      // New tab and image
      const targetImage = document.querySelector("#" + event.target.dataset.targetImg);
      targetImage.classList.toggle("show");
      // Previous tab and image
      const relatedImage = document.querySelector("#" + event.relatedTarget.dataset.targetImg);
      relatedImage.classList.toggle("show");
    });
  }
});

/**
 * Method handling the Breaking News Widget
 *
 * In ideal situation a cookie should prevent the callout from opening if closed previously
 */
// Import JS Cookie librabry
import Cookies from "js-cookie";

const AlertExists = document.getElementById("asideBreakingNews"),
  AlertCloseBtns = document.querySelectorAll(".button-action-minimise");

if (AlertExists !== null) {
  let cookieName;

  if (document.querySelectorAll(".breaking-news-content")[0].id) {
    cookieName = "TZAlertMin-" + document.querySelectorAll(".breaking-news-content")[0].id;
  } else {
    cookieName = "TZAlertMin";
  }

  console.log(cookieName);

  let cookieStatus = Cookies.get(cookieName);
  if (typeof cookieStatus === "undefined") {
    AlertExists.classList.remove("hiddenInfo");
    Cookies.set(cookieName, "0", { expires: 3 });
  }
  if (cookieStatus == 1) {
    AlertExists.classList.add("hiddenInfo");
  } else {
    AlertExists.classList.remove("hiddenInfo");
  }

  AlertCloseBtns.forEach((AlertCloseBtn) => {
    AlertCloseBtn.addEventListener("click", function () {
      cookieStatus = Cookies.get(cookieName);
      if (cookieStatus == 1) {
        AlertExists.classList.remove("hiddenInfo");
        Cookies.set(cookieName, "0", { expires: 3 });
      } else {
        AlertExists.classList.add("hiddenInfo");
        Cookies.set(cookieName, "1", { expires: 3 });
      }
    });
  });
}

/**
 * Filtr odstávek – filtry se vytvoří z karet .card-outage na stránce Odstávky.
 */
import { initOutageFilters } from "./outage-filter.js";

if (document.querySelector(".card-outage")) {
  initOutageFilters();
}

/**
 * Zascrolování na vybranou službu otevřenou v akordeonu
 */
import { Collapse } from "bootstrap";

document.querySelectorAll("[data-accordion-open]").forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();

    const panel = document.querySelector(link.dataset.accordionOpen);
    const anchor = document.querySelector(link.getAttribute("href"));
    if (!panel || !anchor) return;

    anchor.scrollIntoView({ behavior: "smooth", block: "start" });
    history.pushState(null, "", link.getAttribute("href"));

    if (!panel.classList.contains("show")) {
      Collapse.getOrCreateInstance(panel, { toggle: false }).show();
    }
  });
});
